export default __webpack_public_path__ + "static/media/quiz-bg.bbb46e55.png";